var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetUserInfoAsync as InvokeAsync , GetUserInfoSync as InvokeSync}

async function GetUserInfoAsync(LoginToken,Email)
{
    var GetUserInfoPromise = new Promise((resolve, reject) => {
        GetUserInfoSync(LoginToken,Email,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetUserInfoPromise;
}

function GetUserInfoSync(LoginToken,Email,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetUser',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            Email     :Email ,            
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
